// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatReply_reply__7oKub {
  display: flex;
  grid-column-gap: 4px;
  border-radius: 3px;
  font-size: 14px;
  line-height: 18px;
  overflow: hidden;
  margin-bottom: 6px;
}
.ChatReply_reply--is-new__lcqEn {
  margin-left: 8px;
}
.ChatReply_reply--is-new__lcqEn .ChatReply_info__SVmBg {
  cursor: initial;
  background: none;
  max-width: calc(100% - 20px);
}
.ChatReply_reply--is-img__MM8NC .ChatReply_txtWrap__Mwxpg {
  max-width: calc(100% - 48px);
}

.ChatReply_info__SVmBg {
  display: flex;
  grid-column-gap: 8px;
  border-top-right-radius: inherit;
  border-bottom-right-radius: inherit;
  border-left: 3px solid var(--accent-color);
  text-align: left;
  background-color: #fff;
  cursor: pointer;
  max-width: 100%;
  padding: 3px 8px 3px 5px;
}

.ChatReply_txtWrap__Mwxpg {
  max-width: 100%;
}

h4.ChatReply_title__XOEtd,
.ChatReply_title__XOEtd {
  color: var(--accent-color);
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
}

.ChatReply_txt__oA7kQ {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}

.ChatReply_txtImg__h\\+Zm2 {
  color: #526D7A;
}

.ChatReply_img__uz7dW {
  width: 40px;
  height: 40px;
  object-fit: cover;
  object-position: center;
}

.ChatReply_btnClose__dVR3y {
  background: none;
  border: none;
  padding: 0;
  width: 16px;
  height: 16px;
  margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/Chat/ChatReply/ChatReply.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AACF;AACE;EACE,gBAAA;AACJ;AACI;EACE,eAAA;EACA,gBAAA;EACA,4BAAA;AACN;AAII;EACE,4BAAA;AAFN;;AAOA;EACE,aAAA;EACA,oBAAA;EACA,gCAAA;EACA,mCAAA;EACA,0CAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;EACA,wBAAA;AAJF;;AAOA;EACE,eAAA;AAJF;;AAOA;;EAEE,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAJF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAJF","sourcesContent":[".reply {\r\n  display: flex;\r\n  grid-column-gap: 4px;\r\n  border-radius: 3px;\r\n  font-size: 14px;\r\n  line-height: 18px;\r\n  overflow: hidden;\r\n  margin-bottom: 6px;\r\n\r\n  &--is-new {\r\n    margin-left: 8px;\r\n\r\n    .info {\r\n      cursor: initial;\r\n      background: none;\r\n      max-width: calc(100% - 20px);\r\n    }\r\n  }\r\n\r\n  &--is-img {\r\n    .txtWrap {\r\n      max-width: calc(100% - 48px);\r\n    }\r\n  }\r\n}\r\n\r\n.info {\r\n  display: flex;\r\n  grid-column-gap: 8px;\r\n  border-top-right-radius: inherit;\r\n  border-bottom-right-radius: inherit;\r\n  border-left: 3px solid var(--accent-color);\r\n  text-align: left;\r\n  background-color: #fff;\r\n  cursor: pointer;\r\n  max-width: 100%;\r\n  padding: 3px 8px 3px 5px;\r\n}\r\n\r\n.txtWrap {\r\n  max-width: 100%;\r\n}\r\n\r\nh4.title,\r\n.title {\r\n  color: var(--accent-color);\r\n  font-weight: 600;\r\n  font-size: 12px;\r\n  line-height: 14px;\r\n}\r\n\r\n.txt {\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  display: block;\r\n}\r\n\r\n.txtImg {\r\n  color: #526D7A;\r\n}\r\n\r\n.img {\r\n  width: 40px;\r\n  height: 40px;\r\n  object-fit: cover;\r\n  object-position: center;\r\n}\r\n\r\n.btnClose {\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  width: 16px;\r\n  height: 16px;\r\n  margin-left: auto;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reply": `ChatReply_reply__7oKub`,
	"reply--is-new": `ChatReply_reply--is-new__lcqEn`,
	"info": `ChatReply_info__SVmBg`,
	"reply--is-img": `ChatReply_reply--is-img__MM8NC`,
	"txtWrap": `ChatReply_txtWrap__Mwxpg`,
	"title": `ChatReply_title__XOEtd`,
	"txt": `ChatReply_txt__oA7kQ`,
	"txtImg": `ChatReply_txtImg__h+Zm2`,
	"img": `ChatReply_img__uz7dW`,
	"btnClose": `ChatReply_btnClose__dVR3y`
};
export default ___CSS_LOADER_EXPORT___;
